// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:28:39Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci s kontakty subjektu, který zatím není založen a je POUZE ověřen na základní registry - tedy máme jeho id ověření, viz {@link SubjektService#overSubjekt(Subjekt, String)}. Generated from cz.marbes.api.subjekt.KontaktOvereniService.
 */
export default class KontaktOvereniApi {
    /**
     * Načtení všech kontaktů daného subjektu, případně pouze těch, které odpovídají předaným typům.
     *
     * @param overeniId id ověření subjektu
     * @param typyKontaktu seznam požadovaných typů, pokud je prázdný nebo null, vrací se všechny typy
     * @return seznam kontaktů nebo prázdný seznam
     */
    static getSubjektKontakty(overeniId : number, typyKontaktu : TypKontaktu[]) : Promise<Kontakt[]> {
        const uri = serverContextPath + `/api/subjekt/overeni/${overeniId}/kontakt`;
        const headers = undefined;
        const params = { typyKontaktu };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}